module.exports = __webpack_public_path__ + "static/media/w-Width.c24b62bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/w-Width.png
// module id = 192
// module chunks = 0